import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Label,
  TextInput,
  Textarea,
  Checkbox,
} from "flowbite-react";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import SkyClear from "../../../../../img/SkyClear.png";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const InfoFamiliarCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "INFORMACIÓN FAMILIAR";
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [referenciasLaborales, setReferenciasLaborales] = useState([
    {
      nombre: "",
      parentesco: "",
      edadcivil: "",
      domicilio: "",
      viveconeva: "",
      actividadlabo: "",
      ultimogrado: "",
      edad: "",
    },
  ]);
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const { reset } = useForm();
  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleReferenciaChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setReferenciasLaborales((prev) =>
      prev.map((referencia, i) =>
        i === index ? { ...referencia, [name]: value } : referencia
      )
    );
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");
  
    if (printContent) {
      const originalContent = document.body.innerHTML;
  
      const printWindow = window.open('', '', 'width=800,height=600');
  
      if (printWindow) {
        printWindow.document.write('<html><head><title>Vista Previa de Impresión</title>');

        const styles = document.getElementsByTagName("style");
        for (let i = 0; i < styles.length; i++) {
          printWindow.document.write(styles[i].outerHTML);
        }
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
        };
      } else {
        alert("No se pudo abrir la ventana de impresión. Verifique las configuraciones del navegador.");
      }
    }
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFecha = useMutationData({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-visita-bienesinmuebles"],
  });

  const mutatePadresHermanos = useMutationData({
    url: `/padres-hermanos/${evaluadosList_id}`,
    reload: ["evaluado", "padres-hermanos", `${evaluadosList_id}`],
  });

  const mutateConyuge = useMutationData({
    url: `/conyuge/${evaluadosList_id}`,
    reload: ["evaluado", "conyuge", `${evaluadosList_id}`],
  });

  const mutateHijos = useMutationData({
    url: `/hijos/${evaluadosList_id}`,
    reload: ["evaluado", "hijos", `${evaluadosList_id}`],
  });

  const mutateNotasInfoFam = useMutationData({
    url: `/notas_infofam/${evaluadosList_id}`,
    reload: ["evaluado", "notas_infofam", `${evaluadosList_id}`],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  // const [padresHermanos, setPadresHermanos] = useState([
  //   {
  //     nombre: "",
  //     parentesco: "",
  //     edad: "",
  //     estadoCivil: "",
  //     domicilio: "",
  //     viveConEvaluado: false,
  //     actividadLaboral: "",
  //     ultimoGradoEstudios: "",
  //   },
  // ]);

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        puesto: queryEvaluado.data.puesto || "",
        fecha_ingreso: queryEvaluado.data.fecha_ingreso || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <Card className={`mt-4 ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
      <form className={`flex flex-col gap-4 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
        {/* Fecha Visita */}
        <div className="grid grid-cols-3 gap-4">
          <div>
            <Label htmlFor="fecha_infofam" value="FECHA VISITA:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <Controller
              name="fecha_infofam"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_infofam"
                  type="date"
                  placeholder="Seleccionar fecha"
                  {...field}
                  className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                />
              )}
            />
          </div>
          {/* Campo para nombre */}
          <div className="col-span-2">
            <Label htmlFor="name" value="NOMBRE:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="name"
              name="name"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              disabled={true}
              onChange={handleInputChange}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
        </div>
        {/* Campo para RFC */}
        <div className="grid grid-cols-3 gap-4">
          <div>
            <Label htmlFor="rfc" value="RFC:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="rfc"
              name="rfc"
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
              onChange={handleInputChange}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* Género */}
          <div>
            <Label htmlFor="sex" value="SEXO:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="sex"
              name="sex"
              value={generoTexto}
              disabled={true}
              onChange={handleInputChange}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* Estado Civil */}
          <div>
            <Label htmlFor="civilStatus" value="ESTADO CIVIL:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="civilStatus"
              name="civilStatus"
              value={queryEvaluado.data?.estado_civil || ""}
              disabled={true}
              onChange={handleInputChange}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* Escolaridad */}
          <div>
            <Label htmlFor="education" value="ESCOLARIDAD:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="education"
              name="education"
              value={queryEvaluado.data?.escolaridad || ""}
              disabled={true}
              onChange={handleInputChange}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* Fecha de Nacimiento */}
          <div>
            <Label htmlFor="birthDate" value="FECHA DE NACIMIENTO:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="birthDate"
              name="birthDate"
              type="date"
              value={queryEvaluado.data?.fecha_nacimiento || ""}
              disabled={true}
              onChange={handleInputChange}
              className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* CURP */}
          <div>
            <Label htmlFor="curp" value="CURP:" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
            <TextInput
              id="curp"
              name="curp"
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
              onChange={handleInputChange}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
          {/* Empresa */}
          <div className="col-span-1">
            <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
              className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
            />
          </div>
        </div>
      </form>
    </Card>
  );

  const renderPage2 = (index: number) => (
    <Card className={`mt-4 shadow-lg border ${isDarkMode ? "bg-gray-800 border-gray-700" : "bg-white border-gray-300"}`}>
      <h2 className={`text-xl font-bold mb-4 p-2 rounded-t ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        PADRES Y HERMANOS {index + 1}
      </h2>
      <div className={`space-y-4 p-4 rounded-b ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`nombre_ph${index + 1}`}
            value="NOMBRE:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`nombre_ph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`nombre_ph${index + 1}`}
                type="text"
                placeholder="Nombre..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`parentesco_ph${index + 1}`}
            value="PARENTESCO:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`parentesco_ph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`parentesco_ph${index + 1}`}
                type="text"
                placeholder="Parentesco..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`edad_ph${index + 1}`}
            value="EDAD:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`edad_ph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`edad_ph${index + 1}`}
                type="number"
                placeholder="Edad..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`estado_civilph${index + 1}`}
            value="ESTADO CIVIL:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`estado_civilph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`estado_civilph${index + 1}`}
                type="text"
                placeholder="Estado Civil..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`domicilio_ph${index + 1}`}
            value="DOMICILIO:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`domicilio_ph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`domicilio_ph${index + 1}`}
                type="text"
                placeholder="Domicilio..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`vivecon_evaluadoph${index + 1}`}
            value="VIVE CON EL EVALUADO:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`vivecon_evaluadoph${index + 1}`}
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <select
                id={`vivecon_evaluadoph${index + 1}`}
                {...field}
                onChange={(e) => field.onChange(e.target.value === "true")}
                value={field.value.toString()}
                className={`border rounded-md p-2 w-full ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`actividad_laboralph${index + 1}`}
            value="ACTIVIDAD LABORAL:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`actividad_laboralph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`actividad_laboralph${index + 1}`}
                type="text"
                placeholder="Actividad Laboral..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>

        <div className="flex flex-col text-left">
          <Label
            htmlFor={`ultimogrado_estudiosph${index + 1}`}
            value="ÚLTIMO GRADO DE ESTUDIOS:"
            className={`text-left font-semibold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`ultimogrado_estudiosph${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`ultimogrado_estudiosph${index + 1}`}
                type="text"
                placeholder="Último Grado de Estudios..."
                className={`border rounded-md p-2 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
                {...field}
              />
            )}
          />
        </div>
      </div>
    </Card>
  );

  const renderPage3 = (index: number) => (
    <Card className={`mt-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
      <h2 className={`text-xl font-bold mb-4 p-2 ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        CÓNYUGE{" "}
      </h2>
      <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <div className="flex flex-col text-left">
          <Label htmlFor="nombrec" value="NOMBRE:" className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
          <Controller
            name="nombrec"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="nombrec"
                type="text"
                placeholder="Nombre..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label htmlFor="edadc" value="EDAD:" className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`} />
          <Controller
            name="edadc"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="edadc"
                type="text"
                placeholder="Edad..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor="domicilioc"
            value="DOMICILIO:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name="domicilioc"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="domicilioc"
                type="text"
                placeholder="Domicilio..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor="vivecon_evaluadoc"
            value="VIVE CON EL EVALUADO:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name="vivecon_evaluadoc"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <select
                id="vivecon_evaluadoc"
                {...field}
                onChange={(e) => field.onChange(e.target.value === "true")}
                value={field.value.toString()}
                className={`border rounded-md p-2 w-full ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor="actividad_laboralc"
            value="ACTIVIDAD LABORAL:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name="actividad_laboralc"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="actividad_laboralc"
                type="text"
                placeholder="Actividad Laboral..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor="ultimogrado_estudiosc"
            value="ÚLTIMO GRADO DE ESTUDIOS:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name="ultimogrado_estudiosc"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="ultimogrado_estudiosc"
                type="text"
                placeholder="Ultimo Grado de Estudios..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <h2 className={`text-xl font-bold mb-4 p-2 ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
          NOTAS
        </h2>
        <div className="space-y-4">
          <Controller
            name="nota_c"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <Textarea
                id="nota_c"
                {...field}
                onInput={(e) => {
                  const target = e.target as HTMLTextAreaElement;
                  target.style.height = "auto";
                  target.style.height = `${target.scrollHeight}px`;
                }}
                className={`mt-2 p-2 border rounded-md resize-none ${isDarkMode ? "bg-gray-700 border-gray-600 text-gray-300" : "border-gray-300 text-gray-800"}`}
                style={{ height: "auto", overflow: "hidden" }}
              />
            )}
          />
        </div>
        <div className={`mt-4 text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
          <p className="text-left">
            {" "}
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos.{" "}
          </p>
          <p className="text-left">
            Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
            C.V. para que proporcione toda la Información, documentos y todos
            los datos que derive de las evaluaciones de pruebas de confianza que
            se me realicen.{" "}
          </p>
        </div>
      </div>
    </Card>
  );

  const renderPage4 = (index: number) => (
    <Card className={`mt-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
      <h2 className={`text-xl font-bold mb-4 p-2 ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        Hijos {index + 1}
      </h2>
      <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`nombreh${index + 1}`}
            value="NOMBRE:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`nombreh${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`nombreh${index + 1}`}
                type="text"
                placeholder="Nombre..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`edadh${index + 1}`}
            value="EDAD:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`edadh${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`edadh${index + 1}`}
                type="text"
                placeholder="Edad..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`domicilioh${index + 1}`}
            value="DOMICILIO:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`domicilioh${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`domicilioh${index + 1}`}
                type="text"
                placeholder="Domicilio..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`vivecon_evaluadoh${index + 1}`}
            value="VIVE CON EL EVALUADO:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`vivecon_evaluadoh${index + 1}`}
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <select
                id={`vivecon_evaluadoh${index + 1}`}
                {...field}
                onChange={(e) => field.onChange(e.target.value === "true")}
                value={field.value.toString()}
                className={`border rounded-md p-2 w-full ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              >
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`actividad_laboralh${index + 1}`}
            value="ACTIVIDAD LABORAL:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`actividad_laboralh${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`actividad_laboralh${index + 1}`}
                type="text"
                placeholder="Actividad Laboral..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="flex flex-col text-left">
          <Label
            htmlFor={`ultimogrado_estudiosh${index + 1}`}
            value="ÚLTIMO GRADO DE ESTUDIOS:"
            className={`text-left ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
          />
          <Controller
            name={`ultimogrado_estudiosh${index + 1}`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id={`ultimogrado_estudiosh${index + 1}`}
                type="text"
                placeholder="Último Grado de Estudios..."
                {...field}
                className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "border-gray-300"}`}
              />
            )}
          />
        </div>
      </div>
    </Card>
  );

  const renderPage5 = (index: number) => (
    <Card className={`mt-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
      <h2 className={`text-xl font-bold mb-4 p-2 ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        NOTAS
      </h2>
      <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        <Controller
          name="nota_f"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Textarea
              id="nota_f"
              {...field}
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement;
                target.style.height = "auto";
                target.style.height = `${target.scrollHeight}px`;
              }}
              className={`mt-2 p-2 border rounded-md resize-none ${isDarkMode ? "bg-gray-700 border-gray-600 text-gray-300" : "border-gray-300 text-gray-800"}`}
              style={{ height: "auto", overflow: "hidden" }}
            />
          )}
        />
      </div>
      <div className={`mt-4 text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
        <p className="text-left">
          {" "}
          Bajo protesta de decir verdad, hago constar que los datos
          proporcionados son verdaderos.{" "}
        </p>
        <p className="text-left">
          Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de C.V.
          para que proporcione toda la Información, documentos y todos los datos
          que derive de las evaluaciones de pruebas de confianza que se me
          realicen.{" "}
        </p>
      </div>
    </Card>
  );

  const addReferenciaLaboral = () => {
    setReferenciasLaborales([
      ...referenciasLaborales,
      {
        nombre: "",
        parentesco: "",
        edadcivil: "",
        domicilio: "",
        viveconeva: "",
        actividadlabo: "",
        ultimogrado: "",
        edad: "",
      },
    ]);
  };

  const validateAndRemoveEmptyReferences = () => {
    setReferenciasLaborales((prev) =>
      prev.filter((referencia, index) => {
        if (index === 0) return true;
        const isFilled = Object.values(referencia).some(
          (value) => value.trim() !== ""
        );
        return isFilled;
      })
    );
  };

  const handlePageChange = (direction: "next" | "prev") => {
    validateAndRemoveEmptyReferences();
    if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
    } else if (direction === "prev") {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`container mx-auto p-4`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            const formData = {
              ...data,
            };
            console.log("FormData:", formData);

            // Mutación para guardar la Fecha
            mutateFecha.mutate(
              {
                data: formData,
                tipo: "put",
              },
              {
                onSuccess: () => {
                  // Mutación para guardar Padres Hermanos
                  mutatePadresHermanos.mutate(
                    {
                      data: formData,
                      tipo: "post",
                    },
                    {
                      onSuccess: () => {
                        // Mutación para guardar Conyuge
                        mutateConyuge.mutate(
                          {
                            data: formData,
                            tipo: "post",
                          },
                          {
                            onSuccess: () => {
                              // Mutación para guardar Hijos
                              mutateHijos.mutate(
                                {
                                  data: formData,
                                  tipo: "post",
                                },
                                {
                                  onSuccess: () => {
                                    // Mutación para guardar Notas de Información Familiar
                                    mutateNotasInfoFam.mutate(
                                      {
                                        data: formData,
                                        tipo: "post",
                                      },
                                      {
                                        onSuccess: () => {
                                          // Navegar después de todas las mutaciones
                                          navigate(
                                            `/domiciliaria/${evaluadosList_id}`
                                          );
                                        },
                                        onError: (error) => {
                                          console.error(
                                            "Error al guardar Notas de Información Familiar:",
                                            error
                                          );
                                        },
                                      }
                                    );
                                  },
                                  onError: (error) => {
                                    console.error(
                                      "Error al guardar Hijos:",
                                      error
                                    );
                                  },
                                }
                              );
                            },
                            onError: (error) => {
                              console.error("Error al guardar Conyuge:", error);
                            },
                          }
                        );
                      },
                      onError: (error) => {
                        console.error("Error al guardar Padres Hermanos:", error);
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error("Error al guardar Fecha:", error);
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {renderHeader()}
          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && (
            <div>
              {referenciasLaborales.map((_, index) => (
                <div key={index} className={`referencia-${index}`}>
                  {renderPage2(index)}
                </div>
              ))}
              <h2 className={`text-xl font-bold mb-4 p-2 rounded-t ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
                NOTAS
              </h2>
              <div className="space-y-4">
                <Controller
                  name="nota_ph"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Textarea
                      id="nota_ph"
                      {...field}
                      onInput={(e) => {
                        const target = e.target as HTMLTextAreaElement;
                        target.style.height = "auto";
                        target.style.height = `${target.scrollHeight}px`;
                      }}
                      className={`mt-2 p-2 border rounded-md resize-none ${isDarkMode ? "bg-gray-700 border-gray-600 text-gray-300" : "border-gray-300"}`}
                      style={{ height: "auto", overflow: "hidden" }}
                    />
                  )}
                />
              </div>
              <div className="flex justify-center mt-4">
                <div className="w-full max-w-4xl px-4">
                  <div className={`mt-4 text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
                    <p className="text-left">
                      Bajo protesta de decir verdad, hago constar que los datos
                      proporcionados son verdaderos.
                    </p>
                    <p className="text-left">
                      Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY
                      S.A. de C.V. para que proporcione toda la información,
                      documentos y todos los datos que derive de las evaluaciones
                      de pruebas de confianza que se me realicen.
                    </p>
                  </div>
                </div>
              </div>

              {/* Botón en una línea separada */}
              <div className="flex justify-center mt-4">
                <Button color="blue" onClick={addReferenciaLaboral} className={`${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 text-white"}`}>
                  +
                </Button>
              </div>
            </div>
          )}

          {currentPage === 3 && (
            <div>
              {referenciasLaborales.map((_, index) => (
                <div key={index} className={`referencia-${index}`}>
                  {renderPage3(index)}
                </div>
              ))}
            </div>
          )}

          {currentPage === 4 && (
            <div>
              {referenciasLaborales.map((_, index) => (
                <div key={index} className={`referencia-${index}`}>
                  {renderPage4(index)}
                </div>
              ))}
              <h2 className={`text-xl font-bold mb-4 p-2 ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
                NOTAS
              </h2>
              <div className="space-y-4">
                <Controller
                  name="nota_h"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <Textarea
                      id="nota_h"
                      {...field}
                      onInput={(e) => {
                        const target = e.target as HTMLTextAreaElement;
                        target.style.height = "auto";
                        target.style.height = `${target.scrollHeight}px`;
                      }}
                      className={`mt-2 p-2 border rounded-md resize-none ${isDarkMode ? "bg-gray-700 border-gray-600 text-gray-300" : "border-gray-300"}`}
                      style={{ height: "auto", overflow: "hidden" }}
                    />
                  )}
                />
              </div>
              <div className={`mt-4 text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
                <p className="text-left">
                  {" "}
                  Bajo protesta de decir verdad, hago constar que los datos
                  proporcionados son verdaderos.{" "}
                </p>
                <p className="text-left">
                  Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A.
                  de C.V. para que proporcione toda la Información, documentos y
                  todos los datos que derive de las evaluaciones de pruebas de
                  confianza que se me realicen.{" "}
                </p>
              </div>
              <div className="flex justify-center mt-4">
                <Button color="blue" onClick={addReferenciaLaboral} className={`${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 text-white"}`}>
                  +
                </Button>
              </div>
            </div>
          )}

          {currentPage === 5 && (
            <div>
              {referenciasLaborales.map((_, index) => (
                <div key={index} className={`referencia-${index}`}>
                  {renderPage5(index)}
                </div>
              ))}
            </div>
          )}
          {/* Botones de navegación */}
          <div className="flex justify-between mt-4 px-4 mb-4">
            {currentPage < 2 && (
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/domiciliaria/${evaluadosList_id}`);
                }}
                className={`${isDarkMode ? "bg-red-600 hover:bg-red-700 text-white" : "bg-red-500 text-white"}`}
              >
                Cancelar
              </Button>
            )}
            {currentPage > 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange("prev");
                }}
                className={`${isDarkMode ? 'bg-violet-600 text-white hover:bg-violet-900' : 'bg-violet-300 text-white-700'}`}
              >
                Anterior
              </Button>
            )}
            {currentPage < 5 ? (
              <Button
                color="blue"
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange("next");
                }}
                className={`${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 text-white"}`}
              >
                Siguiente
              </Button>
            ) : (
              <div className="flex space-x-4">
                <button
                  type="submit"
                  className={`rounded px-4 py-2 ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 text-white"}`}
                  onClick={validateAndRemoveEmptyReferences}
                >
                  Guardar
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
